import React from "react";
import PropTypes from "prop-types";
import Warning from "../Warning";

const UserEmailWarning = ({ closePopup, setEditingContact }) => {
  return (
    <Warning
      prompt={
        <span
          style={{ width: "426px" }}
          className="flex flex-row text-es-dark-grey text-es-normal font-es-medium tracking-es-wide whitespace-pre pl-3 flex-wrap"
        >
          <p className="text-wrap">
            {`Please `}
            <button
              type="button"
              className="underline tracking-es-wide font-es-medium"
              onClick={() => {
                // close invite popup
                closePopup();
                // take user to contact edit
                setEditingContact(true);
              }}
            >
              add contact email
            </button>
            {` before sending invite.`}
          </p>
        </span>
      }
    />
  );
};

UserEmailWarning.propTypes = {
  closePopup: PropTypes.func,
  setEditingContact: PropTypes.func,
};
UserEmailWarning.defaultProps = {
  closePopup: () => {},
  setEditingContact: () => {},
};

export default UserEmailWarning;
